import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logOutUser } from '../../../../App/AppActions';
import '../../../../Investee/pages/Authentication/Signup.css';
import { Grid } from '@mui/material';

class VerifyEmailPage extends Component {
    render() {
        const { selectedSegment, navigate } = this.props;
        if (selectedSegment === 'investor') {
            return (
                <>
                    <div className="col-md-6 col-sm-12 recur-card">
                        <section id="inner-wrapper" className="text-center">
                            <article>
                                <p className="purple-color">INVESTOR'S CLUB</p>
                                <img alt="" src="/assets/VE.svg" />
                                <div className="request-submitted">
                                    <h3>Verify your email</h3>
                                    <p>
                                        We’ve send details on
                                        <span> {this.props.user.emailId}</span>
                                    </p>
                                </div>
                                <hr />
                                <div
                                    onClick={() => this.props.resendVerifyEmail()}
                                    className="d-flex justify-content-center align-items-center fs14 mt-5 cp"
                                >
                                    <img
                                        alt=""
                                        src="/assets/refresh.png"
                                        style={{
                                            margin: '3px 8px 0 0',
                                            width: '16px',
                                            height: '16px',
                                        }}
                                    />
                                    <span>Resend Verification Email</span>
                                </div>
                                <div
                                    onClick={() =>
                                        this.props.dispatch(logOutUser(navigate, selectedSegment))
                                    }
                                    className="fs14 mt-3 cp"
                                >
                                    <span>Home</span>
                                    <img
                                        alt=""
                                        src="/assets/icon-arrow-forward.svg"
                                        style={{ paddingLeft: '10px' }}
                                    />
                                </div>
                            </article>
                        </section>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={4}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 99,
                            backgroundColor: '#fff',
                            borderRadius: {
                                xs: '43px 43px 0 0',
                                lg: '43px 0 0 0',
                            },
                            width: '100%',
                        }}
                    >
                        <section
                            id="inner-wrapper"
                            className="text-center"
                            style={{ width: '75%' }}
                        >
                            <article>
                                <img alt="" src="/assets/drafts-black.svg" />
                                <div className="request-submitclassted">
                                    <h3 className="mt-4 confEmailHeading">
                                        Please Verify your email
                                    </h3>
                                    <p className="mt-2 confEmailPararaph">
                                        We’ve sent details on{' '}
                                        <span style={{ fontWeight: 'bold' }}>
                                            {this.props.user?.emailId}
                                        </span>
                                        , please be sure to check your spam folder.
                                    </p>
                                </div>
                                <div className="d-flex justify-content-center align-items-center mt-4">
                                    <button
                                        onClick={() => this.props.resendVerifyEmail()}
                                        className="d-flex justify-content-center align-items-center btn btn-primary button resend-email-btn"
                                    >
                                        Resend Verification Email
                                    </button>
                                </div>
                                {
                                    <div
                                        onClick={() =>
                                            this.props.dispatch(
                                                logOutUser(navigate, selectedSegment),
                                            )
                                        }
                                        className="fs14 mt-3 cp"
                                    >
                                        <span style={{ color: '#2F8FFF' }}>Home</span>
                                    </div>
                                }
                            </article>
                        </section>
                    </Grid>
                </>
            );
        }
    }
}

export default connect()(VerifyEmailPage);
